<template>
  <div class="audio-controls">
    <SkipButton 
      class="audio-controls__skip" 
      :isFoward="false" 
      @click="toRewind()" 
      v-if="!props.isWithoutSkip"
    />
    <button class="audio-controls__play-btn" @click="toTogglePlayStatus()">
      <PlaybackStatus 
        class="audio-controls__play" 
        :isPlaying="isTheAudioPlaying" 
        :isLoading="isLoadingTheAudio" 
        :speed="speed" 
        :color="'var(--audio-btn-icon)'" 
      />
    </button>
    <SkipButton 
      class="audio-controls__skip" 
      :isFoward="true" 
      @click="toFoward()" 
      v-if="!props.isWithoutSkip" 
    />
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';
  import { useAudioPlayerState } from '../../composables/computedValues';
  import { useAudioControl } from '../../composables/audioControl';
  //-------------------------------------
  import SkipButton from '../../ui/SkipButton/SkipButton.vue';
  import PlaybackStatus from '../../ui/PlaybackStatus/PlaybackStatus.vue';
  //-------------------------------------
  const store = useStore();
  const props = defineProps({
    //ID Подкаста
    idPodcast: { type: Number, required: true },
    //Убрать кнопки перемотки
    isWithoutSkip: { type: Boolean, required: false }
  });
  //-------------------------------------
  const { podcast, isPlaying, speed, isAnyLoading, isReady, currentTime } = useAudioPlayerState();
  //-------------------------------------
  const { toggleAudio, seekToTime } = useAudioControl();
  //-------------------------------------
  //Фокус на этом подкасте
  const isFocusTheAudio = computed(() => {
    return store.state.Audioplayer.activePodcastId == props.idPodcast;
  });
  //Подгружается лт это аудио
  const isLoadingTheAudio = computed(() => {
    return !isReady.value || (isFocusTheAudio.value && isAnyLoading.value)
  });
  //Проигрывается ли это аудио
  const isTheAudioPlaying = computed(() => {
    return isFocusTheAudio.value && isPlaying.value;
  });
  //-------------------------------------
  //Промотать вперед
  const toFoward = () => {
    const time = Math.min(podcast.value.audio_length, currentTime.value + 15);
    seekToTime(time, props.idPodcast);
  };
  //Промотать назад
  const toRewind = () => {
    const time = Math.max(currentTime.value - 15, 0);
    seekToTime(time, props.idPodcast);
  };
  //Возобновить/остановить аудио
  const toTogglePlayStatus = () => {
    if(isAnyLoading.value) return;
    toggleAudio(props.idPodcast);
  }
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>